import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-navlist', 'MY_SHORTCUTS', 'Mani īsceļi');
Labels.set('ui-navlist', 'REMOVE_SHORTCUT', 'Dzēst īsceļu');
Labels.set('ui-navlist', 'ADD_SHORTCUT', 'Pievienot lapu īsceļiem');
Labels.set('ui-navlist', 'EDIT_SHORTCUTS', 'Labot īsceļus');
Labels.set('ui-navlist', 'FINISH_EDITING', 'Saglabāt izmaiņas');
Labels.set('ui-navlist', 'BACK', 'Atpakaļ');
